import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  CancelReasonOption,
  CancelTimingOption,
} from "components/pages/AccountComponent/BillingComponent/CancelSubscription/types";
import { fromSnakeCase } from "helper/string";

export enum SubscriptionStatus {
  ACTIVE = "active",
  CANCELLED = "cancelled",
}

type SubscriptionStatusType = {
  isLoading?: boolean;
  status: SubscriptionStatus;
  data?: {
    cancelTiming: CancelTimingOption;
    cancelDate: string;
    cancelReason: CancelReasonOption | null;
    cancelReasonOther?: string;
  };
  isCancelSubscriptionFormOpen?: boolean;
};

const initialState: SubscriptionStatusType = {
  isLoading: false,
  status: SubscriptionStatus.ACTIVE,
  data: undefined,
  isCancelSubscriptionFormOpen: false,
};

export const subscriptionSlice = createSlice({
  name: "subscription",
  initialState,
  reducers: {
    setIsLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.isLoading = payload;
    },
    setSubscriptionStatus: (
      state,
      { payload: { status, data } }: PayloadAction<SubscriptionStatusType>,
    ) => {
      state.status = status;

      if (data) {
        state.data = {
          cancelTiming: fromSnakeCase(data.cancelTiming) as CancelTimingOption,
          cancelDate: data.cancelDate,
          cancelReason: data.cancelReason,
        };
      }
    },
    setIsCancelSubscriptionFormOpen: (
      state,
      { payload }: PayloadAction<boolean>,
    ) => {
      state.isCancelSubscriptionFormOpen = payload;
    },
  },
});

export const {
  setIsLoading,
  setSubscriptionStatus,
  setIsCancelSubscriptionFormOpen,
} = subscriptionSlice.actions;
